"use client";
import Section from "../components/Section";
import { Grid2 } from "@repo/ui";
import WebinarCard from "../components/webinar/WebinarCard";
import {
  EventType,
  GET_EVENTS,
  TimeLineView,
} from "@/graphql/queries/event-query";
import { useSuspenseQuery } from "@apollo/client";

const RecommendedWebinar = () => {
  const commonParams = {
    eventType: EventType.WEBINAR,
    timeLineView: TimeLineView.UPCOMING,
    page: 1,
    perPage: 3,
  };

  const { data: webinarEvent } = useSuspenseQuery(GET_EVENTS, {
    variables: {
      ...commonParams,
    },
  });
  const webinars = webinarEvent?.events?.data ?? [];
  if (webinars.length === 0) return null;
  return (
    <Section
      title="Recommended webinars"
      className="bg-gradient-to-b from-blue-50 to-white"
    >
      <Grid2 container spacing={5}>
        {webinars?.map((webinar) => (
          <Grid2 key={webinar.id} size={{ sm: 12, md: 4, lg: 4 }}>
            <WebinarCard
              title={webinar.serviceName}
              eventDates={webinar.eventDates}
              time={webinar.eventDetails.eventTime}
              author={webinar.eventDetails?.trainer?.name}
              pageSlug={webinar.pageSlug}
              coverSrc={webinar.serviceImage}
            />
          </Grid2>
        ))}
      </Grid2>
    </Section>
  );
};

export default RecommendedWebinar;
